import React from 'react'
import { Route } from 'react-router-dom'
import MessagesConfigView from 'components/MessagesConfigView'

const MessagesConfigurationsRoutes = ({ match }) => (
  <Route path={match.path} component={MessagesConfigView} />
)

export default MessagesConfigurationsRoutes
